<div class="pswp__download-tooltip" tabindex="-1"
[class.pswp__download-tooltip--fade-in]="isOpened || isAnimating"
[style.display]="isOpened ? 'block' : ''">
  <div class="tm_pswp-info">
    <div class="tm_pswp-usage-info" *ngIf="data">
      <!-- 版權提示  -->
      <div class="tm_pswp-rights-tip">
        {{ authorityText }}
        <!-- ICON  -->
        <a *ngIf="authorityImg" href="{{ authorityLink }}" target="_blank" class="tm_pswp-copyright copyright-link" title="{{ authorityText }}[{{'openNewWindow' | translate}}]">
          <img src="{{ authorityImg }}" alt="{{ authorityText }}">
        </a>
      </div>
      <a href="#" role="button" tabindex="0" (click)="$event.preventDefault(); handleCopyWithFeedback(citationEl)"><div class="tm_pswp-cite-tip"><i class="fa fa-clone" aria-hidden="true"></i>&nbsp;複製授權引用資訊</div></a>
      <!-- 引用文字  -->
      <textarea class="tm_pswp-rights-citation" value="{{downloadRightsCitation}}" readonly (click)="handleCopyWithFeedback(citationEl)" #citationEl></textarea>
    </div>
  </div>
</div>